import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchAllDevices, fetchDevicesByUserId, reFetchAllDevices, reFetchDevicesByUserId, registerDevice
} from '../../../actions/device';
import DeviceItem from "../DeviceItem/DeviceItem";
import CircularProgress from 'material-ui/CircularProgress';
import AddIcon from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {empty, emptyObject, USER_ROLE_ID} from "../../../util/util";
import UserController from '../../../models/user/userController';
import {FETCHING_DEVICES_INTERVAL_TIME} from "../../../api/constants";
import './DevicesList.css';

class DevicesList extends Component {
  
  constructor() {
    super();
    
    this.state = {
      addDeviceDialogOpen: false,
      serialNumber: null,
      description: null,
      serialNumberErrorMessage: null
    }
  }
  
  componentWillMount() {

    let userRoleId = UserController._getLoggedInUserRoleId();

    if(userRoleId === USER_ROLE_ID.ADMIN) {
      this.props.fetchAllDevices();
    }
    else if(userRoleId === USER_ROLE_ID.USER) {
      let userId = UserController._getLoggedInUserId();
      this.props.fetchDevicesByUserId(userId);
    }
  }
  
  componentDidMount() {
    this.interval = this._setFetchingDevicesInterval();
  }

  componentWillUnmount() {
    this._clearFetchingDevicesInterval();
  }
  
  render() {
    return(
      <div className="page-wrapper clearfix">
        {this._renderFetchingDataFailedMessage()}
        {this._renderLoader()}
        <div className="devices-wrapper">
          {this._renderDevices()}
          {this._renderAddDeviceDialog()}
        </div>
        {this._renderAddDeviceButton()}
      </div>
    );
  }
  
  _renderFetchingDataFailedMessage() {
    
    let fetchSuccess = this.props.fetchSuccess;
    
    if(!fetchSuccess)
      return(
        <div className="failedMessageWrapper">
          <p>No devices found</p>
        </div>
      );
  }
  
  _renderLoader() {
    
    let loading = this.props.loading;
    
    if(loading)
      return(
        <div className="loaderWrapper">
          <CircularProgress size={80} thickness={7} />
        </div>
      );
  }
  
  _renderDevices() {
  
    let fetchSuccess = this.props.fetchSuccess,
        loading = this.props.loading;
  
    if(fetchSuccess && !loading) {
  
      let devices = this.props.devices;
      
      if (devices && !emptyObject(devices)) {
        
        return Object.keys(devices).map(key => {
      
          let device = devices[key];
  
          return <DeviceItem key={device.id} device={device}/>;
        });
      }
    }
  }
  
  _renderAddDeviceButton() {
    
    let userRoleId = UserController._getLoggedInUserRoleId();
  
    if(userRoleId === USER_ROLE_ID.USER) {
      return (
        <div className="add-device-wrapper">
          <button onClick={() => this._openAddDeviceDialog()}>
            <AddIcon className="icon"/> <span className="label">Add new device</span>
          </button>
        </div>
      );
    }
  }
  
  _renderAddDeviceDialog() {

    let actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={() => this._closeAddDeviceDialog()}/>,

      <RaisedButton
        label="Add"
        primary={true}
        keyboardFocused={true}
        onClick={() => this._addDevice()}/>
    ];

    return (
      <Dialog
        title="Add new device"
        actions={actions}
        open={this.state.addDeviceDialogOpen}
        onRequestClose={() => this._closeAddDeviceDialog()}
        contentClassName="dialog-content">
        <div>
          <TextField
            hintText="Serial No."
            floatingLabelText="Serial No."
            name="serialNumber"
            onChange={(event) => this._onInputChange(event)}
            errorText={this.state.serialNumberErrorMessage}/>
        </div>
        <div>
          <TextField
            hintText="Device name"
            floatingLabelText="Device name"
            name="description"
            onChange={(event) => this._onInputChange(event)}/>
        </div>
      </Dialog>
    );
  }
  
  _setFetchingDevicesInterval() {
    
    let userRoleId = UserController._getLoggedInUserRoleId();
    
    return setInterval(() => {
      if(userRoleId === USER_ROLE_ID.ADMIN) {
        this.props.reFetchAllDevices();
      }
      else if(userRoleId === USER_ROLE_ID.USER) {
        
        let userId = UserController._getLoggedInUserId();
        this.props.reFetchDevicesByUserId(userId);
      }
      
    }, FETCHING_DEVICES_INTERVAL_TIME);
  }
  
  _clearFetchingDevicesInterval() {
    clearInterval(this.interval);
  }

  _openAddDeviceDialog() {
    this.setState({ addDeviceDialogOpen: true });
  }
  
  _closeAddDeviceDialog() {
    this.setState({ addDeviceDialogOpen: false, serialNumberErrorMessage: null });
  }
  
  _onInputChange(event) {
    let { name, value } = event.target;
    this.setState({ [name]: value });
  }
  
  _addDevice() {
  
    let {serialNumber, description} = this.state;
    
    if(empty(serialNumber)) {
  
      this.setState({serialNumberErrorMessage: null});
      
      let userId = UserController._getLoggedInUserId();
      
      let deviceData = {
        serialNumber: serialNumber,
        description: description,
        owner:{id: userId}
      };
      
      this.props.registerDevice(deviceData);
      this._closeAddDeviceDialog();
    }
    else{
      this.setState({serialNumberErrorMessage: "Serial No. required"});
    }
  }
}

const mapStateToProps = state => ({
  fetchSuccess: state.rootReducer.device.fetchSuccess,
  loading: state.rootReducer.device.loading,
  devices: state.rootReducer.device.all
});

export default connect(mapStateToProps, {
  fetchAllDevices,
  reFetchAllDevices,
  fetchDevicesByUserId,
  reFetchDevicesByUserId,
  registerDevice
})(DevicesList);


// WEBPACK FOOTER //
// ./src/common/components/DevicesList/DevicesList.js